import { protectedReq } from '../../helpers/requestHelper';

const queryString = filters => {
    const params = new URLSearchParams();
    Object.entries(filters || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.set(key, value);
    });
    const query = params.toString();
    return query ? `?${query}` : '';
};

const request = async (path, body, method = 'GET') => {
    try {
        const resp = await protectedReq(path, body, method);
        const json = await resp.json();
        if (!resp.ok || !json.status)
            return { status: false, msg: json.msg || 'request-err' };
        return Array.isArray(json.resp)
            ? { status: true, data: json.resp }
            : { status: true, ...json.resp };
    } catch (error) {
        return { status: false, msg: 'request-err' };
    }
};

export const getClients = filters => request(`clients${queryString(filters)}`);
export const getClientsOverview = filters => request(`clients/overview${queryString(filters)}`);
export const getClientProductInsights = filters => request(`clients/insights/products${queryString(filters)}`);
export const getClientGeographyInsights = filters => request(`clients/insights/geography${queryString(filters)}`);
export const getClientSeasonalityInsights = filters => request(`clients/insights/seasonality${queryString(filters)}`);
export const getClientDetail = id => request(`clients/${id}`);
export const getClientOrders = (id, filters) => request(`clients/${id}/orders${queryString(filters)}`);
export const updateClientTags = (id, tags) => request(`clients/${id}/tags`, { tags }, 'PUT');
export const addClientNote = (id, body) => request(`clients/${id}/notes`, { body }, 'POST');
export const deleteClientNote = (id, noteId) => request(`clients/${id}/notes/${noteId}`, {}, 'DELETE');
export const exportClients = filters => request('clients/export', filters, 'POST');

export const getCommercialSeasons = () => request('clients/seasons');
export const saveCommercialSeason = season => request('clients/seasons', season, 'POST');
export const updateCommercialSeason = (id, season) => request(`clients/seasons/${id}`, season, 'PUT');
export const deleteCommercialSeason = id => request(`clients/seasons/${id}`, {}, 'DELETE');

export const getClientBranches = async () => {
    const result = await request('branch/list');
    if (!result.status) return result;
    const branches = result.branches || result.data || [];
    return { status: true, branches };
};
